import { PegTypes } from "types/PegTypes";
export const InitGameBoardState2: number[][] = [
  [
    PegTypes.InvisiblePeg,
    PegTypes.InvisiblePeg,
    PegTypes.FilledSlot,
    PegTypes.FilledSlot,
    PegTypes.FilledSlot,
    PegTypes.InvisiblePeg,
    PegTypes.InvisiblePeg,
  ],
  [
    PegTypes.InvisiblePeg,
    PegTypes.InvisiblePeg,
    PegTypes.FilledSlot,
    PegTypes.FilledSlot,
    PegTypes.FilledSlot,
    PegTypes.InvisiblePeg,
    PegTypes.InvisiblePeg,
  ],
  [
    PegTypes.FilledSlot,
    PegTypes.FilledSlot,
    PegTypes.FilledSlot,
    PegTypes.FilledSlot,
    PegTypes.FilledSlot,
    PegTypes.FilledSlot,
    PegTypes.FilledSlot,
  ],
  [
    PegTypes.FilledSlot,
    PegTypes.FilledSlot,
    PegTypes.FilledSlot,
    PegTypes.EmptySlot,
    PegTypes.FilledSlot,
    PegTypes.FilledSlot,
    PegTypes.FilledSlot,
  ],
  [
    PegTypes.FilledSlot,
    PegTypes.FilledSlot,
    PegTypes.FilledSlot,
    PegTypes.FilledSlot,
    PegTypes.FilledSlot,
    PegTypes.FilledSlot,
    PegTypes.FilledSlot,
  ],
  [
    PegTypes.InvisiblePeg,
    PegTypes.InvisiblePeg,
    PegTypes.FilledSlot,
    PegTypes.FilledSlot,
    PegTypes.FilledSlot,
    PegTypes.InvisiblePeg,
    PegTypes.InvisiblePeg,
  ],
  [
    PegTypes.InvisiblePeg,
    PegTypes.InvisiblePeg,
    PegTypes.FilledSlot,
    PegTypes.FilledSlot,
    PegTypes.FilledSlot,
    PegTypes.InvisiblePeg,
    PegTypes.InvisiblePeg,
  ],
];
